import { useUserContext } from "@context/UserContext";
import type { User } from "types/UserZendesk";
import { checkCpfExists, searchUsers, zafClient } from "@services/Zendesk";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export function useNewUser() {
    const [error, setError] = useState<string | null>(null);
    const [errorEmail, setErrorEmail] = useState<string | null>(null);
    const [existUser, setExistUser] = useState<User | null>(null);
    const [existUserEmail, setExistUserEmail] = useState<User | null>(null);
    const [isChecking, setIsChecking] = useState(false);
    const [vinculate, setVinculate] = useState(false);
    const { setNewUserFormData, newUserFormData } = useUserContext();
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        cpf_3: newUserFormData?.cpf_3 || '',
        name: newUserFormData?.name || '',
        phone: newUserFormData?.phone || '',
        email: newUserFormData?.email || '',
        cnpj_regex: newUserFormData?.cnpj_regex || ''
    });

    async function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
        const { name, value } = e.target;
        let newValue = value;

        if (name === 'cpf') {
            newValue = value.replace(/\D/g, '').slice(0, 11);
            setError(null);
        } else if (name === 'phone') {
            newValue = value.replace(/\D/g, '');
        }

        setFormData(prev => ({
            ...prev,
            [name]: newValue,
        }));
    }

    async function handleProceed() {
        setError('');
        setErrorEmail('');
        setExistUser(null);
        setExistUserEmail(null);

        if (formData.cpf_3.length !== 11) {
            setError('CPF com 11 dígitos inválido.');
            return;
        }

        setIsChecking(true);
        try {
            const { exists, user } = await checkCpfExists(zafClient, formData.cpf_3);
            const existEmail = await searchUsers(zafClient, `email:${formData.email}`);

            if (exists) {
                setError('Já existe um usuário com este CPF');
                setExistUser(user?.user ?? null);
                return;
            }

            if (existEmail.length > 0) {
                setErrorEmail('Já existe um usuário com este email');
                setExistUserEmail(existEmail[0]);
                return;
            }

            setNewUserFormData({
                name: formData.name,
                phone: formData.phone,
                email: formData.email,
                cpf_3: formData.cpf_3,
                cnpj_regex: formData.cnpj_regex.replace(/\D/g, ''),
                tipoConta: ''
            });

            if (vinculate) {
                navigate("/select-account-new-user");
            } else {
                navigate("/review-user-account-new-user");
            }

        } finally {
            setIsChecking(false);
        }
    }

    useEffect(() => {
        setError('');
        setExistUser(null);
    }, [formData.cpf_3]);

    useEffect(() => {
        setErrorEmail('');
        setExistUserEmail(null);
    }, [formData.email]);

    return {
        formData,
        error,
        errorEmail,
        existUser,
        existUserEmail,
        isChecking,
        vinculate,
        setVinculate,
        handleProceed,
        handleChange,
        navigate
    }
}